<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

// Freshness of one overview (RED-317 §8): a coloured dot and, as a pill, the
// period or the status word. Colours match the matrix cells.
const props = defineProps({
  status: { type: String, required: true },
  text: { type: String, default: null },
  pill: { type: Boolean, default: true },
})

const { t } = useI18n()

const tone = computed(
  () =>
    ({
      fresh: { dot: 'bg-green-600', text: 'text-green-700', pill: 'bg-green-50' },
      stale: { dot: 'bg-amber-500', text: 'text-amber-700', pill: 'bg-amber-50' },
      missing: { dot: 'bg-gray-300', text: 'text-gray-500', pill: 'bg-gray-100' },
    })[props.status] ?? { dot: 'bg-gray-300', text: 'text-gray-500', pill: 'bg-gray-100' },
)

const label = computed(() => props.text ?? t(`messages.admin.market_overviews.status.${props.status}`))
</script>

<template>
  <span
    class="inline-flex items-center gap-1.5 text-xs font-medium whitespace-nowrap"
    :class="[tone.text, pill ? `${tone.pill} rounded-full px-2 py-0.5` : '']"
    :data-status="status"
  >
    <span class="inline-block size-1.5 shrink-0 rounded-full" :class="tone.dot" />
    {{ label }}
  </span>
</template>
